import React from "react";
import {copyToClipboard} from "../lib/utils";
import {useInlineAnnotation} from "./InlineAnnotation";

const CopyToClipboardButton = ({
  getText = (e) => "",
  getExtraFlavors = null,      // (e) => { [mimeType]: string } — extra clipboard flavors alongside text/plain
  getAltText = null,           // (e) => string — text to copy on Alt+click; enables Alt+click mode
  getAltExtraFlavors = null,   // (e) => { [mimeType]: string } — extra flavors for Alt+click path
  getFallbackAnnotation = null,  // () => string — annotation text when multi-flavor falls back to text/plain
  className = "",
  disabled = false,
  title = "Copy to clipboard",
  showAnnotation = true,
  label = null,
}) => {
  const { ref, show, visible, message, type } = useInlineAnnotation();

  const handleClick = (e) => {
    // Alt+click copies via getAltText when provided (PLEX-5844)
    if (e.altKey && getAltText) {
      e.preventDefault();
      const altFlavors = getAltExtraFlavors ? getAltExtraFlavors(e) : null;
      const altFallback = altFlavors && getFallbackAnnotation
        ? () => show(getFallbackAnnotation(), "info")
        : null;
      copyToClipboard(
        getAltText(e),
        showAnnotation ? () => show("Copied as JSON", "success") : null,
        altFlavors,
        altFallback
      );
      return;
    }
    const extraFlavors = getExtraFlavors ? getExtraFlavors(e) : null;
    const onFallback = getFallbackAnnotation
      ? () => show(getFallbackAnnotation(), "info")
      : null;
    copyToClipboard(
      getText(e),
      showAnnotation ? () => show("Copied", "success") : null,
      extraFlavors,
      onFallback
    );
  };

  return (
    <span ref={ref} className="inline-annotation-wrapper">
      <button
        disabled={disabled}
        title={title}
        className={`copy-to-clipboard${label ? '' : ' glyphicon glyphicon-copy'}${className ? ' ' + className : ''}${disabled ? ' disabled' : ''}`}
        onClick={handleClick}
      >
        {label && (
          <span className="searchbox-icon-label">
            <span className="glyphicon glyphicon-copy" aria-hidden="true" />
            <span className="searchbox-icon-label__text">{label}</span>
          </span>
        )}
      </button>
      {visible && (
        <span className={`inline-annotation inline-annotation-${type}`}>{message}</span>
      )}
    </span>
  );
};

export default CopyToClipboardButton;